export const UPDATE_WIRE_STEP_INDEX = "UPDATE_WIRE_STEP_INDEX";
export const UPDATE_WIRE_CURRENCY = "UPDATE_WIRE_CURRENCY";
export const UPDATE_ACH_STEP_INDEX = "UPDATE_ACH_STEP_INDEX";
export const UPDATE_ACH_CONFIRM_DATA = "UPDATE_ACH_CONFIRM_DATA";
export const UPDATE_NEED_ADD_BANK = "UPDATE_NEED_ADD_BANK";
